import React from 'react';

import { ChangeHandler } from 'src/presentation/components/pages/integrations/types';
import { InputType } from 'src/presentation/components/forms/InputField';
import { MaskedField } from 'src/presentation/components/pages/integrations/editorComponents/EditorFields';
import { Row, Section } from 'src/presentation/components/forms/Layout';

const CredentialsSection = ({
  attr,
  hasCredentials,
  onAttrChange,
}: {
  attr: string;
  hasCredentials: boolean;
  onAttrChange: (attr: string) => ChangeHandler;
}): JSX.Element => {
  return (
    <Section header="Basic Authentication">
      <Row>
        <MaskedField
          attr={`${attr}.username`}
          data-aid={`${attr}-username`}
          isMasked={hasCredentials}
          label="Username"
          onChange={onAttrChange(`${attr}.username`)}
          placeholder="ex. admin@gladly.com"
          showClearButton={hasCredentials}
        />
      </Row>

      <Row>
        <MaskedField
          attr={`${attr}.password`}
          data-aid={`${attr}-password`}
          isMasked={hasCredentials}
          label="Password"
          onChange={onAttrChange(`${attr}.password`)}
          placeholder="••••••••••"
          showClearButton={hasCredentials}
          type={InputType.password}
        />
      </Row>

      <Row>
        <MaskedField
          attr={`${attr}.realm`}
          data-aid={`${attr}-realm`}
          isMasked={hasCredentials}
          label="Realm"
          onChange={onAttrChange(`${attr}.realm`)}
          placeholder="realm"
          showClearButton={hasCredentials}
        />
      </Row>
    </Section>
  );
};

export default CredentialsSection;
